// src/components/report/DeliveredTargets.js
import React from 'react';

const DeliveredTargets = ({ targets }) => (
  <div className="bg-white rounded-xl p-6 shadow-lg mb-6">
    <h3 className="text-lg font-bold mb-6 text-[#234363] text-right">السبائك المستلمة</h3>
    <div className="space-y-4">
      {targets.map((target, index) => (
        <div key={index} className="flex justify-between items-center pb-4 border-b border-gray-100 last:border-0">
          <span className="text-sm text-gray-600 ltr">
            {new Date(target.delivery_date).toLocaleDateString('ar-EG')}
          </span>
          <span className="text-[#234363] font-medium">
            {target.name_ar}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default DeliveredTargets;